import { menuItems } from '@/mocks/restaurantData';

export default function MenuSection() {
  return (
    <section id="menu" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 reveal">
        <div className="inline-flex items-center gap-2 text-primary-400 font-script text-5xl">
          &mdash; Our Menu &mdash;
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.3]">
            人気メニュー
          </h2>
        </div>

        <div className="space-y-12 md:space-y-20">
          {menuItems.map((item, index) => (
            <div
              key={item.id}
              className={`reveal flex flex-col md:flex-row items-center gap-8 md:gap-12 ${
                index % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              {/* 写真 */}
              <div className="w-full md:w-1/2 max-w-md aspect-square rounded-2xl overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.name}
                  title={`${item.name} - Trattoria Sole人気メニュー`}
                  className={`w-full h-full object-center ${
                    item.id === 5 ? 'object-contain' : 'object-cover'
                  }`}
                />
              </div>

              {/* 文字情報 */}
              <div className="w-full md:w-1/2">
                <div className="flex items-baseline justify-between gap-4 mb-2">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    {item.name}
                  </h3>
                  <span className="font-heading text-xl md:text-2xl font-bold text-primary-400 whitespace-nowrap">
                    {item.price}
                  </span>
                </div>
                <p className="font-script text-2xl md:text-2xl text-foreground-400 mb-3">
                  {item.nameEn}
                </p>
                <p className="text-foreground-300 text-sm md:text-base leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14 reveal">
          <p className="inline-flex items-center gap-2 text-primary-400/50 font-script text-3xl">
           Buon appetito
          </p>
        </div>
      </div>
    </section>
  );
}